import React from 'react';
import { Section, Entry, List, Title } from '../Section';
const list = ['Turkish — Native', 'English — C1 (Advanced)'];

export const Languages = ({ ...props }) => {
    return (
        <Section {...props}>
            <Entry>
                <Title id='languages'>Languages</Title>
                <Entry>
                    <List list={list} numberOfCols='1' />
                </Entry>
            </Entry>
        </Section>
    );
};
